@use 'sass:color' as sassColor;
@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;
@use '../../styling/form-controls.scss' as *;
@use '../../styling/buttons.scss' as *;

$hover-shadow-primary: sassColor.adjust($color-primary-purple, $alpha: -0.8);
$hover-shadow-error: sassColor.adjust($color-primary-red, $alpha: -0.8);

.DropdownButton {
  @extend %font-family-primary;
  @extend %form-control-dropdown-disabled;

  // <button> overrides
  @extend %form-control-border;

  cursor: pointer;
  outline: none;
  text-align: left;

  &:hover {
    box-shadow: 0 0 0 3px $hover-shadow-primary;
  }

  &:focus {
    border-color: $color-primary-purple;
    box-shadow: 0 0 0 3px $hover-shadow-primary;
  }

  // styling
  background-color: $theme-dropdown-background-color;
  border-radius: 6px;
  color: $theme-color-dropdown;
  display: inline-grid;
  gap: 8px;
  font-size: $font-size-normal;
  font-weight: $font-weight-semibold;
  height: $button-height;
  line-height: 30px;
  overflow: hidden;
  min-width: $dropdown-button-min-width;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  padding-left: 16px;

  &.isLeftBondedFilters {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;

    &:hover,
    &:focus {
      box-shadow: -1px -2px 0px 1px $hover-shadow-primary,
        -1px 2px 0px 1px $hover-shadow-primary,
        -2px 0px 0px 1px $hover-shadow-primary;
    }

    &:focus {
      border-color: $color-primary-purple;
    }
  }

  &.isRightBondedFilters {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-left: 0px;

    &:hover,
    &:focus {
      box-shadow: 0 0;
    }
  }

  &.isTopBondedFilters {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;

    &:hover,
    &:focus {
      box-shadow: -1px -2px 0px 1px $hover-shadow-primary,
        -1px 2px 0px 1px $hover-shadow-primary,
        -2px 0px 0px 1px $hover-shadow-primary;
    }

    &:focus {
      border-color: $color-primary-purple;
    }
  }

    &.isBottomBondedFilters {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-top: 0px;

    &:hover,
    &:focus {
      box-shadow: 0 0;
    }
  }

  &.isFocus {
    border-color: $color-primary-purple;
    box-shadow: 0 0 0 3px $hover-shadow-primary;
  }

  &.isHighlighted {
    background-color: $theme-dropdown-selected-background-color;
    border-color: $theme-dropdown-selected-outline-color;
    border-width: 1.5px;
  }

  &.isInvalid {
    border-color: $color-primary-red;

    &:hover,
    &:focus-within {
      box-shadow: 0 0 0 3px $hover-shadow-error;
    }
  }

  .errorIcon {
    display: grid;
    color: $color-warning-orange;
  }

  .modelIconWrapper {
    font-size: 0;
    height: 100%;
    display: inline-grid;
    align-items: center;
    justify-content: center;
    color: $theme-filter-icon-color;

    path {
      color: $theme-filter-icon-color;
    }
  }

  .filledModelIconWrapper {
    @extend .modelIconWrapper;

    path {
      fill: $theme-filter-icon-color;
    }
  }

  .downIconWrapper {
    height: 100%;
    display: inline-grid;
    justify-content: center;
    align-items: center;

    path {
      color: $theme-filter-icon-color;
    }
  }

  &:disabled {
    cursor: default;
    color: $theme-color-readonly-field-text;

    svg {
      color: $color-grey-disabled;

      path {
        color: $color-grey-disabled;
      }
    }
  }

  .Children {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre;
  }
}

.DropdownButtonIcon {
  @extend .DropdownButton;

  grid-template-columns: auto minmax(0, 1fr) 24px;
}

.DropdownButtonNoIcon {
  @extend .DropdownButton;

  grid-template-columns: minmax(0, 1fr) 24px;
}

.FilterDropdownMinMaxWidth {
  gap: 6px;
  min-width: 64px;
  max-width: 200px;
  padding-left: 12px;
  padding-right: 4px;
  width: max-content;
}
